import { useCallback, useRef } from 'react'
import { useUnmount } from 'react-use'

import { useCartDialog } from '../../../app/_providers/CartProvider.client'
import { QuickBuyContainer } from '../../../brunswick/containers/QuickBuyContainer'
import { modalAnimationDuration } from '../../../brunswick/styles/constants'

export function useAddToCartWithMiniCartToggle() {
  const { open: openCartDialog } = useCartDialog()
  const quickBuyService = QuickBuyContainer.useContainer()
  const slideOutTimeout = useRef<number>()

  const onAddToCart: typeof quickBuyService.addToCart = useCallback(
    params => {
      quickBuyService.addToCart({ ...params })

      const openMiniCartOnAdd = params?.openMiniCartOnAdd ?? true

      if (!openMiniCartOnAdd) return

      slideOutTimeout.current = window.setTimeout(() => {
        openCartDialog()
      }, modalAnimationDuration)
    },
    [quickBuyService, openCartDialog]
  )

  useUnmount(() => {
    if (!slideOutTimeout.current) return

    clearTimeout(slideOutTimeout.current)
  })

  return {
    addToCart: onAddToCart,
  }
}
